import { COLORS } from "../../../../constants";
/**
 * label styles
 */
export var inputLabelSxPropsFn = function (_a) {
    var sizeData = _a.sizeData;
    return ({
        fontSize: sizeData.fontSize,
        transform: "translate(14px, ".concat(sizeData.label, ") scale(1)"),
        "&.MuiInputLabel-shrink": {
            transform: "translate(14px, -9px) scale(0.75)",
        },
    });
};
/**
 * hide input so chip can be used
 */
export var formControlAsChipSxProps = {
    display: "none",
    background: "#ff00",
};
/**
 * Popover menu styles
 */
export var menuSxProps = {
    ".MuiPaper-root": function (theme) {
        var _a;
        return (_a = {
                mt: 1,
                border: "1px solid ".concat(COLORS.P_OUTLINE)
            },
            _a[theme.breakpoints.down("sm")] = {
                width: "100%",
            },
            _a);
    },
    ".MuiList-root": {
        p: "8px !important",
    },
};
/**
 * select styles
 */
export var selectSxProps = function (_a) {
    var sizeData = _a.sizeData;
    return ({
        ".MuiOutlinedInput-notchedOutline": {
            legend: {
                fontSize: sizeData.legend,
            },
        },
        ".MuiSelect-outlined": {
            color: COLORS.P_MED_HIGH_EMPHASIS,
            "&.MuiSelect-select": {
                textAlign: "left",
                textAlignLast: "left",
                minHeight: "0",
                height: "auto",
                pr: 7,
                pl: 3,
                lineHeight: "20px",
                pt: sizeData.padding,
                pb: sizeData.padding,
                display: "flex",
                alignItems: "center",
            },
        },
        "&.MuiInput-underline": {
            ".MuiSelect-select": {
                textAlign: "left",
                textAlignLast: "left",
                minHeight: "0",
                height: "auto",
                pr: 7,
                pl: 3,
                lineHeight: "200px",
                pt: sizeData.padding,
                pb: sizeData.padding,
                display: "flex",
                alignItems: "center",
            },
            "&::before": {
                borderBottom: "none !important",
            },
        },
        ".MuiSelect-icon": {
            width: "19px",
        },
        borderRadius: 2,
    });
};
/**
 * Popover menu Item styles
 */
export var menuItemSxProps = {
    minWidth: 235,
    px: 3,
    borderRadius: 2,
    "&.Mui-selected": {
        background: "transparent",
    },
    "&:hover, &.Mui-selected:hover": {
        bgcolor: COLORS.SECONDARY_HOVER,
    },
    "&:active, &.Mui-selected:active": {
        bgcolor: COLORS.SECONDARY_PRESSED,
    },
    minHeight: [40],
};
